import React, { createContext, useContext, useState } from 'react';
import UpgradePlanModal from '~/components/UpgradePlanModal';

const UpgradePlanModalContext = createContext();

export const useUpgradePlanModal = () => {
    return useContext(UpgradePlanModalContext);
};

export const UpgradePlanModalProvider = ({ children }) => {
    const [showModal, setShowModal] = useState(false);

    const showUpgradePlanModal = () => {
        setShowModal(true);
    };

    const hideUpgradePlanModal = () => {
        setShowModal(false);
    };

    return (
        <UpgradePlanModalContext.Provider value={{ showUpgradePlanModal, hideUpgradePlanModal }}>
            {children}
            <UpgradePlanModal show={showModal} onClose={hideUpgradePlanModal} />
        </UpgradePlanModalContext.Provider>
    );
};
